import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { AboutSection } from './components/AboutSection';
import { FooterSection } from './components/FooterSection';
export function App() {
  return <main className="bg-zinc-950 min-h-screen" data-id="element-0" data-mp="3fb9jzcn93go5">
      <HeroSection data-id="element-1" data-mp="2rkdwgrptv7mp" />
      <ServicesSection data-id="element-2" data-mp="2rlys6knvowm5" />
      <TestimonialsSection data-id="element-3" data-mp="2rlfbf79yse9p" />
      <AboutSection data-id="element-4" data-mp="2rikqzfqyatga" />
      <FooterSection data-id="element-5" data-mp="2mmceka451ect" />
    </main>;
}